<div fxLayout="column" fxLayoutGap="32px">
  <h2 mat-dailog-title>{{'confirm_delete.header' | translate}}</h2>
  <mat-dialog-content>
    <div class="margin">{{'confirm_delete.sure' | translate}} <b>{{data}}</b>?</div>
    <mat-form-field style="width: 100%" class="margin">
      <input matInput placeholder="{{'confirm_delete.enter_text' | translate}}" [(ngModel)]="inputValue">
    </mat-form-field>
  </mat-dialog-content>
  <mat-dialog-actions align="end">
    <button class="btn" mat-button mat-dialog-close>{{'global.cancel' | translate | uppercase}}</button>
    <button class="btn btn-default" mat-raised-button color="warn" [disabled]="!canDelete()" [mat-dialog-close]="true">
      {{'confirm_delete.delete_word' | translate | uppercase}}
    </button>
  </mat-dialog-actions>
</div>
